export {};

document.addEventListener("started-guest", () => {
    document.location.href = '/';
});

document.addEventListener("started-user", () => {
    if (app.user.user?.isSubscribed) {
        document.location.href = config.routes.activation_success;
        return;
    }
});

function continueWithYearlyPlan(event: Event): void {
    event.preventDefault();

    if (!window.app) {
        return;
    }

    app.voyoForms.submit(event.target as HTMLFormElement,
        async (data) => {
            const termsAgreed = data.generalTerms === "on";

            if (!termsAgreed) {
                return;
            }
            
            document.location.href = config.routes.activation_credit_card_yearly;
            return;
        }
    );
}

window.continueWithYearlyPlan = continueWithYearlyPlan;
